import React, { useEffect, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Carousel } from 'flowbite-react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { EventServicesById, ExistingEventServices } from '../../services/EventServices';
import Swal from 'sweetalert2';
import RegisterUserEvent from '../../services/RegisterEventServices';
import './EventInformationComponent.css';

import moment from 'moment/moment';

import 'moment/locale/es';
import VideoPlayer from '../vimeo/VimeoPlayerComponent';
import SendEmail from '../correos/CorreoComponent';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LivePlayer from '../vimeo/LiveVimeoPlayerComponent';
import logsUserService from '../../services/LogsUserActionService';


// Función para redimensionar la imagen
const resizeImage = (file, width, height) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        if (img.width === width && img.height === height) {
          const imageUrl = URL.createObjectURL(file);
          resolve(imageUrl);
        } else {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedImageUrl = URL.createObjectURL(blob);
              resolve(resizedImageUrl);
            } else {
              reject(new Error('Failed to convert canvas to blob'));
            }
          }, 'image/jpeg');
        }
      };
      img.src = reader.result;
    };

    reader.onerror = (error) => reject(error);

    reader.readAsDataURL(file);
  });
};

const EventInformationComponent = () => {
  const [eventData, setEventData] = useState([]);
  const [error, setError] = useState(null);
  const [resizedImages, setResizedImages] = useState([]);
  const [isRegisterEvent, setRegisterEvent] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [countdownEnded, setCountdownEnded] = useState(false);
  const { token, idUser, name, lastName, email } = useAuth();
  const [isValidUrl, setIsValidUrl] = useState(false);
  const { id_event } = useParams(); // Capturamos el id del evento
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getEventById = async () => {
      try {
        setLoading(true);
        const eventById = await EventServicesById(token, id_event);
        console.log("Datos del evento recibidos de la API:", eventById);

        // Redimensionamos las imágenes de los altavoces
        const resizedImagesPromises = eventById[0].speakers.map(async (speaker) => {
          const response = await fetch(speaker.picture);
          const blob = await response.blob();
          return resizeImage(blob, 500, 500);
        });

        if (Array.isArray(eventById) && eventById.length > 0) {
          console.log("Primer evento en el array:", eventById[0]);
          setEventData(eventById); // Solo actualiza el estado si la respuesta es un array
        } else {
          console.log("No se encontraron datos.");
          setEventData([]);  // Si no hay datos, mantén el estado vacío
        }

        const resizedImagesUrls = await Promise.all(resizedImagesPromises);
        setResizedImages(resizedImagesUrls);


      } catch (error) {
        setError(error);
        console.log("Error al obtener el evento:", error);
      }
    };

    // consultamos si esta registrado a otro evento
    const userData = {
      event_id: id_event,
      user_id: Number(idUser)
    };

    console.log(eventData);
    console.log(userData);

    const ExistRegister = async () => {
      try {
        await ExistingEventServices(token, userData).then((result) => {
          if (result['length'] > 0) {
            setRegisterEvent(true);
          } else {
            setRegisterEvent(false);
          }
        });
      } catch (error) {
        console.error(error);
      }
    }

    getEventById();
    ExistRegister();

  }, [idUser, id_event, token]);

  useEffect(() => {
    console.log("Datos actualizados del evento:", eventData); // Ver los datos actualizados después de que `setEventData` se ejecute
  }, [eventData]);

  useEffect(() => {
    const updateCountdown = () => {
      const date = eventData[0]?.date; // 'YYYY-MM-DD'
      const time = eventData[0]?.time; // 'HH:MM:SS'

      if (date && time) {
        const [year, month, day] = date.split('-').map(Number);
        const [hours, minutes, seconds] = time.split(':').map(Number);

        // Crear el objeto Date para la fecha y hora objetivo en la zona horaria local
        const localDate = new Date(year, month - 1, day, hours, minutes, seconds);

        // Obtener la fecha y hora actual en la zona horaria local
        const currentDate = new Date();

        // Convertir ambos a UTC para una comparación consistente
        const targetDateUTC = new Date(localDate.toISOString());
        const currentDateUTC = new Date(currentDate.toISOString());

        const difference = targetDateUTC - currentDateUTC;

        if (difference > 0) {
          setTimeLeft({
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((difference % (1000 * 60)) / 1000),
          });
        } else if (!countdownEnded) {
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          handleCountdownEnd();
          setCountdownEnded(true);
        }
      }
    };

    const handleCountdownEnd = () => {
      console.log('Countdown ended');
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [eventData, countdownEnded, idUser, id_event, token]);


  const formatSpeakerName = (name) => {
    // Verifica si el nombre ya contiene "Dr."
    if (name.startsWith('Dr.')) {
      return name;
    }
    // Si no, agrega "Dr." al inicio
    return `Dr. ${name}`;
  };

  const registerEvents = async (eventId) => {
    try {
      // Asegúrate de que los valores de eventId y idUser sean correctos
      if (!eventId || !idUser) {
        throw new Error("Event ID or User ID is missing");
      }

      const userData = {
        event_id: eventId,
        user_id: Number(idUser)
      };

      // insertamos la participacion
      RegisterUserEvent(token, userData).then((response) => {
        console.log("RegisterUserEvent response:", response);
        if (response.status === 201) {
          // consultamos el evento
          EventServicesById(token, eventId).then((eventResults) => {
            console.log("EventServicesById results:", eventResults);
            const icon = '/images/icons/Ico-Check.png';
            if (eventResults.length > 0) {
              Swal.fire({
                html: ` <div class="custom-icon-image">
                            <img class="ico-check-popup" src="${icon}" alt="?#">
                          </div>
                        <div class="text-center mx-lg-5 text-principal-swal ApisRegular" style="
                             margin-bottom: -10px;
                             overflow: hidden!important;
                             font-size: 25px;
                             color: #4E2485 !important; 
                             margin-top: 1rem
                        ">
                          Usted se ha registrado en el evento:
                          <span class="ApisBold">${eventResults[0]['name']}: </span>
                          <span class="ApisRegular"">${eventResults[0]['description']}</span><br><br>
                        </div>
                        <span classname="text-welcome-swal ApisBold" style="
                             color: #0dc5b2 !important;
                             font-size: 30px;
                        ">¡Bienvenido!</span>`,
                showCloseButton: true,
                width: '600px',
                showConfirmButton: false,
                customClass: {
                  title: 'text-principal-swal ApisRegular text-dark-purple-800',
                  htmlContainer: 'text-welcome-swal ApisRegular text-center text-dark-purple-800 text-event-swal',
                  popup: "swal-styles"
                }
              });

              setRegisterEvent(true);
              // enviamos correo 
              SendEmail(email, eventResults[0]['name']);
            }
          }).catch((error) => {
            console.error("Error fetching event by ID:", error);
          });
        } else {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: "Ya estás inscrito en este evento",
            customClass: {
              title: "text-center"
            },
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          });
        }
      }).catch((error) => {
        console.error("Error registering user event:", error);
        if (error.status === 409) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: "Ya estás inscrito en este evento",
            customClass: {
              title: "text-center"
            },
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          });
        } else {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: "Ocurrió un error al registrar el evento",
            customClass: {
              title: "text-center"
            },
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          });
        }
      });
    } catch (error) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: error.message,
        customClass: {
          title: "text-center"
        },
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
      console.error("Error in try-catch block:", error);
    }
  }

  const downloadEventCalendar = async (dateInit, time, dateEnd, title, description, location, url) => {
    console.log(dateInit, time, dateEnd, title, description, location, url);

    // Función para formatear fechas en formato YYYYMMDD
    const formatDate = (date) => {
      const pad = (num) => (num < 10 ? '0' + num : num);
      return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
    };

    // Crear objetos Date para las fechas de inicio y fin
    const startDate = new Date(dateInit); // dateInit debe estar en formato YYYY-MM-DD  // dateEnd debe estar en formato YYYY-MM-DD

    // Ajustar la hora si se proporciona
    const [startHours, startMinutes, startSeconds] = time.split(':').map(Number);
    startDate.setUTCHours(startHours, startMinutes, startSeconds);

    // Formatear fechas de inicio y fin
    const startDateTime = formatDate(startDate);
    const endDateTime = formatDate(startDate);

    // creamos el archivo ics
    const icsData = `
      BEGIN:VCALENDAR
        VERSION:2.0
        PRODID:-//Obesidadalacartann.com.co//MOC//ES
        CALSCALE:GREGORIAN
        BEGIN:VTIMEZONE
        TZID:America/Bogota
        LAST-MODIFIED:20231222T233358Z
        TZURL:https://www.tzurl.org/zoneinfo-outlook/America/Bogota
        X-LIC-LOCATION:America/Bogota
        BEGIN:STANDARD
        TZNAME:-05
        TZOFFSETFROM:-0500
        TZOFFSETTO:-0500
        DTSTART:19700101T000000
        END:STANDARD
        END:VTIMEZONE
        BEGIN:VEVENT
        DTSTAMP:${formatDate(new Date())}
        UID:${Date.now()}@moc.Obesidadalacartann.com
        DTSTART:${startDateTime}
        DTEND:${endDateTime}
        SUMMARY:${title}
        URL:${url}
        DESCRIPTION:${description}
        LOCATION:${location}
        TRANSP:OPAQUE
        END:VEVENT
        END:VCALENDAR
    `;

    // Crear un blob y una URL de descarga
    const blob = new Blob([icsData], { type: 'text/calendar' });
    const urlBlob = URL.createObjectURL(blob);

    // Crear un enlace de descarga
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = `${title}.ics`; // Nombre del archivo descargado
    document.body.appendChild(a); // Añadir el enlace al DOM
    a.click(); // Simular un clic en el enlace
    document.body.removeChild(a); // Eliminar el enlace del DOM
    URL.revokeObjectURL(urlBlob); // Revocar la URL del objeto

    // Crear el enlace para Google Calendar
    const googleCalendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${startDateTime}/${endDateTime}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&url=${encodeURIComponent(url)}`;
    window.open(googleCalendarLink, '_blank');
  };

  console.log(eventData);
  return (
    <>
      <div className="breadcrumb-section mb-3">
        <Breadcrumb aria-label="Default breadcrumb example container main-section p-0">
          <ol className="flex items-center container main-section p-0">
            <BreadcrumbItem className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white" href="#">
              <Link
                to="/eventos"
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
              >
                Eventos
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white" href="#">
              <Link
                to="/eventos"
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
                onClick={() => {logsUserService(idUser, `Clic en ${eventData?.state_events === 'Memorias' ? 'Memorias' : 'Próximo eventos'}`, token)}}
              >
                {eventData?.map((event, index) => (
                  <div key={index} className='ApisBold'>
                    {event.state_events === 'memory' ? 'Memorias' : 'Próximo eventos'}
                  </div>
                ))}
              </Link>
            </BreadcrumbItem>
          </ol>
        </Breadcrumb>
      </div>

      {/* card principal */}
      <div className="container main-section">
        <div className="row m-0 p-0">
          {eventData?.map((event, index) => (
            <React.Fragment key={index}>
              {event.state_events === 'event' && event.state_transmition === 'planned' && (
                <div key={index} className="col-12 col-md-11 col-lg-12 event-info">
                  <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5">
                    {/* Contenedor del contenido principal */}
                    <div className="w-full lg:w-3/4 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                      <h6 className='ApisBold  py-2 lg:fs-2 xl:fs-3 md:fs-4 text-lavender'>{event.name}</h6>
                      <div className="flex items-start text-custom-purple-500">
                        <Breadcrumb aria-label="Default breadcrumb example">
                          <BreadcrumbItem className="flex items-start text-md text-white hover:text-white dark:text-white dark:hover:text-white">
                            <img src="/images/icons/calendario.png" className="w-10 h-8 object-fit-contain" alt="calendario" />
                          </BreadcrumbItem>
                          <BreadcrumbItem className="flex items-start text-md ApisRegular text-white hover:text-white dark:text-white dark:hover:text-white">
                            <span className='text-custom-purple-500'>{moment(event.date).format('DD [de] MMMM [de] YYYY')} {moment(event.time, 'HH:mm:ss').format('h:mm A')}</span>
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </div>

                      <div className="max-w-1xl mx-auto w-full bg-custom-purple-100 p-6 text-center rounded-3xl">
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="relative mx-auto mb-4">
                                <img className="w-72 h-70 rounded-full mx-auto" src={resizedImages[index]} alt={"Speaker Image " + index} />
                                <React.Fragment>
                                  {/* Imagen visible solo en PC */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information w-14 h-14 hidden lg:block absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />

                                  {/* Imagen visible solo para tablet */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information-tablet w-14 h-14 hidden md:block lg:hidden absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />

                                  {/* Imagen visible solo en móvil */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information-movil w-14 h-14 block md:hidden absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />
                                </React.Fragment>
                              </div>
                              <div className="p-6">
                                <h2 className="text-custom-purple-500 text-xl ApisBold mb-2 mt-2">Speaker: {formatSpeakerName(speaker.name)}</h2>
                                <p className="text-custom-purple-500 text-md mb-1">{speaker.profession}</p>
                                <p className="text-custom-purple-500 text-sm mb-4">{event.description}</p>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                    </div>

                    {/* Contenedor del temporizador y botón */}
                    <div className="w-full lg:w-1/4 mt-2 lg:mt-0 flex flex-col items-center justify-center">
                      <div className="bg-custom-purple-100 w-full rounded-xl mb-4 flex flex-col">

                        <p className="text-custom-purple-500 px-4 pt-2 m-0 ApisBold text-xl sm:text-xl">Faltan:</p>
                        <div className='container p-0 m-0'>
                          <div className="flex justify-center items-center gap-2 scale w-full">
                            {/* Días */}
                            {/* <div className="flex flex-col items-center justify-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.days).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-lavender-light rounded-lg p-2 sm:p-3">
                                    <p className="fs-5 font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-gray-500 mt-1 text-xs">Días</p>
                            </div> */}

                            {/* Horas */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.hours).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Horas</p>
                            </div>

                            {/* : Segundos */}
                            <div className="flex flex-col items-center gap-0">
                              <div className="flex">
                                <div key={index} className="">
                                    <p className="text-[2rem] font-bold text-dark-puple">:</p>
                                  </div>
                              </div>
                              <p className="text-gray-500 mt-1 text-xs"></p>
                            </div>
  
                            {/* Minutos */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.minutes).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Minutos</p>
                            </div>

                            {/* : Segundos */}
                            <div className="flex flex-col items-center gap-0">
                              <div className="flex">
                                <div key={index} className="">
                                    <p className="text-[2rem] font-bold text-dark-puple">:</p>
                                  </div>
                              </div>
                              <p className="text-gray-500 mt-1 text-xs"></p>
                            </div>

                            {/* Segundos */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.seconds).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Segundos</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        className={`flex justify-center items-center w-full sm:w-80 h-12 sm:h-18 text-xl sm:text-[2.5rem] btn-register font-bold sm:px-6 rounded-2xl ${isRegisterEvent
                          ? 'p-12 bg-gray-300 ApisBold text-gray cursor-not-allowed' // Estilo cuando isRegisterEvent es true
                          : 'p-12 bg-custom-btn-register ApisBold text-white hover:bg-custom-hover-btn-register focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-60' // Estilo cuando isRegisterEvent es false
                          }`}
                        onClick={() => {!isRegisterEvent && registerEvents(event.id); logsUserService(idUser, `Clic en Regístrese - evento N° ${event.id}`, token) }}
                        disabled={isRegisterEvent} // Desactiva el botón cuando isRegisterEvent es true
                      >
                        {!isRegisterEvent ? 'Regístrese' : 'Registrado'}
                      </button>

                      {isRegisterEvent ? (
                        <OverlayTrigger
                          placement="bottom"
                          className="bg-purple"
                          overlay={<Tooltip id="tooltip-bottom">Guarda este evento en tu calendario favorito</Tooltip>}
                        >
                          <button onClick={() => downloadEventCalendar(event.date, event.time, event.date, event.name, event.description, event.place)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-12 fs-3 mt-4">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                            </svg>
                          </button>
                        </OverlayTrigger>
                      ) : ('')}
                    </div>
                  </div>
                </div>
              )}

              {event.state_events === 'memory' && event.state_transmition === 'planned' && (
                <div key={index} className="col-12 col-md-11 col-lg-12 event-info">
                  <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5">
                    {/* Contenedor del contenido principal */}
                    <div className="w-full lg:w-3/4 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                      <h6 className='ApisBold  py-2 lg:fs-2 xl:fs-3 md:fs-4 text-lavender'>{event.name}</h6>
                      <div className="flex items-start text-custom-purple-500">
                        <Breadcrumb aria-label="Default breadcrumb example">
                          <BreadcrumbItem className="flex items-start text-md text-white hover:text-white dark:text-white dark:hover:text-white">
                            <img src="/images/icons/calendario.png" className="w-10 h-8 object-fit-contain" alt="calendario" />
                          </BreadcrumbItem>
                          <BreadcrumbItem className="flex items-start text-md ApisRegular text-white hover:text-white dark:text-white dark:hover:text-white">
                          <span className='text-custom-purple-500'>{moment(event.date).format('DD [de] MMMM [de] YYYY')} {moment(event.time, 'HH:mm:ss').format('h:mm A')}</span>
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </div>

                      <div className="max-w-1xl mx-auto w-full bg-custom-purple-100 p-6 text-center rounded-3xl">
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="relative mx-auto mb-4">
                                <img className="w-72 h-70 rounded-full mx-auto" src={resizedImages[index]} alt={"Speaker Image " + index} />
                                <React.Fragment>
                                  {/* Imagen visible solo en PC */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information w-14 h-14 hidden lg:block absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />

                                  {/* Imagen visible solo para tablet */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information-tablet w-14 h-14 hidden md:block lg:hidden absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />

                                  {/* Imagen visible solo en móvil */}
                                  <img
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                    className="flag-information-movil w-14 h-14 block md:hidden absolute left-1/2 transform -translate-x-1/2 bottom-0 -translate-x-20 bg-green-400 dark:border-gray-800 rounded-full"
                                  />
                                </React.Fragment>
                              </div>
                              <div className="p-6">
                                <h2 className="text-custom-purple-500 text-xl ApisBold mb-2 mt-2">Speaker: {formatSpeakerName(speaker.name)}</h2>
                                <p className="text-custom-purple-500 text-md mb-1">{speaker.profession}</p>
                                <p className="text-custom-purple-500 text-md mb-1">{event.description}</p>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                    </div>

                    {/* Contenedor del temporizador y botón */}
                    <div className="w-full lg:w-1/4 mt-2 lg:mt-0 flex flex-col items-center justify-center">
                      <div className="bg-custom-purple-100 w-full rounded-xl mb-4 flex flex-col">

                        <p className="text-custom-purple-500 px-4 pt-2 m-0 ApisBold text-xl sm:text-xl">Faltan:</p>
                        <div className='container p-0 m-0'>
                          <div className="flex justify-center items-center gap-2 scale w-full">
                            {/* Días */}
                            {/* <div className="flex flex-col items-center justify-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.days).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-lavender-light rounded-lg p-2 sm:p-3">
                                    <p className="fs-5 font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-gray-500 mt-1 text-xs">Días</p>
                            </div> */}

                            {/* Horas */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.hours).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Horas</p>
                            </div>

                            {/* : Segundos */}
                            <div className="flex flex-col items-center gap-0">
                              <div className="flex">
                                <div key={index} className="">
                                    <p className="text-[2rem] font-bold text-dark-puple">:</p>
                                  </div>
                              </div>
                              <p className="text-gray-500 mt-1 text-xs"></p>
                            </div>

                            {/* Minutos */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.minutes).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Minutos</p>
                            </div>

                            {/* : Segundos */}
                            <div className="flex flex-col items-center gap-0">
                              <div className="flex">
                                <div key={index} className="">
                                    <p className="text-[2rem] font-bold text-dark-puple">:</p>
                                  </div>
                              </div>
                              <p className="text-gray-500 mt-1 text-xs"></p>
                            </div>

                            {/* Segundos */}
                            <div className="flex flex-col items-center">
                              <div className="flex space-x-1">
                                {String(timeLeft.seconds).padStart(2, '0').split('').map((digit, index) => (
                                  <div key={index} className="bg-custom-lavender rounded-lg px-1 sm:px-3">
                                    <p className="text-[4rem] lg:text-[3rem] xl:text-[4rem] font-bold mt-2 text-dark-puple">{digit}</p>
                                  </div>
                                ))}
                              </div>
                              <p className="text-custom-purple-500 ApisRegular mt-1 text-xs">Segundos</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        className={`flex justify-center items-center w-full sm:w-80 h-12 sm:h-18 text-xl sm:text-[2.5rem] btn-register font-bold sm:px-6 rounded-2xl ${isRegisterEvent
                          ? 'p-12 bg-gray-300 ApisBold text-gray cursor-not-allowed' // Estilo cuando isRegisterEvent es true
                          : 'p-12 bg-custom-btn-register ApisBold text-white hover:bg-custom-hover-btn-register focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-60' // Estilo cuando isRegisterEvent es false
                          }`}
                        onClick={() => {!isRegisterEvent && registerEvents(event.id); logsUserService(idUser, `Clic en Regístrese - evento N° ${event.id}`, token)}}
                        disabled={isRegisterEvent} // Desactiva el botón cuando isRegisterEvent es true
                      >
                        {!isRegisterEvent ? 'Regístrese' : 'Registrado'}
                      </button>

                      {isRegisterEvent ? (
                        <OverlayTrigger
                          placement="bottom"
                          className="bg-purple"
                          overlay={<Tooltip id="tooltip-bottom">Guarda este evento en tu calendario favorito</Tooltip>}
                        >
                          <button onClick={() => downloadEventCalendar(event.date, event.time, event.date, event.name, event.description, event.place)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-12 fs-3 mt-4">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                            </svg>
                          </button>
                        </OverlayTrigger>
                      ) : ('')}
                    </div>
                  </div>
                </div>
              )}

              {event.state_events === 'event' && event.state_transmition === 'live' && (
                <div key={index} className="col-12 col-md-11 col-lg-12 event-info">
                  <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5">
                    {/* Contenedor del contenido principal */}
                    <div className="w-full lg:w-3/4 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                      <h6 className='ApisBold lg:fs-2 xl:fs-3 md:fs-4 text-lavender'>{event.name}</h6>
                      <div className="flex items-start text-custom-purple-500">
                        <Breadcrumb aria-label="Default breadcrumb example">
                        <BreadcrumbItem className="flex items-start text-md text-white hover:text-white dark:text-white dark:hover:text-white">
                            <img src="/images/icons/calendario.png" className="w-10 h-8 object-fit-contain" alt="calendario" />
                          </BreadcrumbItem>
                          <BreadcrumbItem className="flex items-start text-md ApisRegular text-white hover:text-white dark:text-white dark:hover:text-white">
                            <span className='text-custom-purple-500'>{moment(event.date).format('DD [de] MMMM [de] YYYY')} {moment(event.time, 'HH:mm:ss').format('h:mm A')}</span>
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </div>

                      <div className="max-w-1xl mx-auto w-full text-center rounded-3xl">
                        <LivePlayer videoUrl={event.url_streaming} idEvent={event.id} />
                      </div>
                    </div>

                    {/* pc */}
                    <div className="hidden md:hidden lg:block xl:block w-full lg:w-1/4 flex flex-col items-center justify-center mt-3 md:mt-0 sm:mt-0">
                      <div className="bg-custom-purple-100 w-full p-3 rounded-xl mb-3 flex flex-col mt-2 md:mt-0 sm:mt-0">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-20 h-20 rounded-full mr-3"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="ApisBold text-sm mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-start justify-start mt-4">
                                <div className="flex-1 align-start text-left border-r border-purple-800 pr-1">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      <iframe
                        className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                        title="chatMoc"
                        src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                      ></iframe>
                    </div>

                    {/* tablet celular */}
                    <div className="block md:block lg:hidden xl:hidden w-full lg:w-1/4 flex flex-col items-center justify-center">
                      <div className="bg-custom-purple-100 w-full p-4 rounded-xl mb-3 flex flex-col">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-24 h-24 rounded-full mr-4"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="font-bold text-xl mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-center mt-4">
                                <div className="flex-1 text-left border-r border-purple-800 pr-4">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      <iframe
                        className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                        title="chatMoc"
                        src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                      ></iframe>
                    </div>
                  </div>
                </div>
              )}

              {event.state_events === 'memory' && event.state_transmition === 'finished' && (
                <div key={index} className="col-12 col-md-11 col-lg-12 event-info">
                  <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5">
                    {/* Contenedor del contenido principal */}
                    <div className="w-full lg:w-3/4 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                    <h6 className='ApisBold lg:fs-2 xl:fs-3 md:fs-4 text-lavender'>{event.name}</h6>
                      <div className="flex items-start text-custom-purple-500">
                        <Breadcrumb aria-label="Default breadcrumb example">
                          <BreadcrumbItem className="flex items-start text-md text-white hover:text-white dark:text-white dark:hover:text-white">
                            <img src="/images/icons/calendario.png" className="w-10 h-8 object-fit-contain" alt="calendario" />
                          </BreadcrumbItem>
                          <BreadcrumbItem className="flex items-start text-md ApisRegular text-white hover:text-white dark:text-white dark:hover:text-white">
                            <span className='text-custom-purple-500'>{moment(event.date).format('DD [de] MMMM [de] YYYY')} {moment(event.time, 'HH:mm:ss').format('h:mm A')}</span>
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </div>

                      <div className="max-w-1xl mx-auto w-full text-center rounded-3xl">
                        <VideoPlayer videoUrl={event.url_video} idEvent={event.id} />
                      </div>
                    </div>

                    {/* Contenedor del temporizador y botón */}

                    {/* pc */}
                    <div className="hidden md:hidden lg:block xl:block w-full lg:w-1/4 flex flex-col items-center justify-center mt-3 md:mt-0 sm:mt-0">
                      <div className="bg-custom-purple-100 w-full p-3 rounded-xl mb-3 flex flex-col mt-2 md:mt-0 sm:mt-0">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-20 h-20 rounded-full mr-3"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="ApisBold text-sm mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-center mt-4">
                                <div className="flex-1 align-start text-left border-r border-purple-800 pr-1">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      {event.is_chat_visible ? (
                        <iframe
                          className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                          title="chatMoc"
                          src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                        ></iframe>
                      ) : ('')}
                    </div>

                    {/* tablet celular */}
                    <div className="block md:block lg:hidden xl:hidden w-full lg:w-1/4 flex flex-col items-center justify-center">
                      <div className="bg-custom-purple-100 w-full p-4 rounded-xl mb-3 flex flex-col">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-24 h-24 rounded-full mr-4"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="font-bold text-xl mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-center mt-4">
                                <div className="flex-1 text-left border-r border-purple-800 pr-4">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      {event.is_chat_visible ? (
                        <iframe
                          className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                          title="chatMoc"
                          src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                        ></iframe>
                      ) : ('')}
                    </div>
                  </div>
                </div>
              )}

              {event.state_events === 'event' && event.state_transmition === 'finished' && (
                <div key={index} className="col-12 col-md-11 col-lg-12 event-info">
                  <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5">
                    {/* Contenedor del contenido principal */}
                    <div className="w-full lg:w-3/4 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                      <h6 className='ApisBold lg:fs-2 xl:fs-3 md:fs-4 text-lavender'>{event.name}</h6>
                      <div className="flex items-start text-custom-purple-500">
                        <Breadcrumb aria-label="Default breadcrumb example">
                          <BreadcrumbItem className="flex items-start text-md text-white hover:text-white dark:text-white dark:hover:text-white">
                            <img src="/images/icons/calendario.png" className="w-10 h-8 object-fit-contain" alt="calendario" />
                          </BreadcrumbItem>
                          <BreadcrumbItem className="flex items-start text-md ApisRegular text-white hover:text-white dark:text-white dark:hover:text-white">
                            <span className='text-custom-purple-500'>{moment(event.date).format('DD [de] MMMM [de] YYYY')} {moment(event.time, 'HH:mm:ss').format('h:mm A')}</span>
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </div>

                      <div className="max-w-1xl mx-auto w-full text-center rounded-3xl">
                        <VideoPlayer videoUrl={event.url_video} idEvent={event.id} />
                      </div>
                    </div>

                    {/* Contenedor del temporizador y botón */}
                    {/* pc */}
                    <div className="hidden md:hidden lg:block xl:block w-full lg:w-1/4 flex flex-col items-center justify-center mt-3 md:mt-0 sm:mt-0">
                      <div className="bg-custom-purple-100 w-full p-3 rounded-xl mb-3 flex flex-col mt-2 md:mt-0 sm:mt-0">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-20 h-20 rounded-full mr-3"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="ApisBold text-sm mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-start justify-start mt-4">
                                <div className="flex-1 align-start text-left border-r border-purple-800 pr-1">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      <iframe
                        className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                        title="chatMoc"
                        src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                      ></iframe>
                    </div>

                    {/* tablet celular */}
                    <div className="block md:block lg:hidden xl:hidden w-full lg:w-1/4 flex flex-col items-center justify-center">
                      <div className="bg-custom-purple-100 w-full p-4 rounded-xl mb-3 flex flex-col">
                        {/* card speakers */}
                        <Carousel indicators={false} autoPlay={true} interval={500}>
                          {eventData[0]?.speakers.map((speaker, index) => (
                            <React.Fragment key={index}>
                              <div className="flex items-center">
                                <img
                                  className="w-24 h-24 rounded-full mr-4"
                                  src={resizedImages[index]} // Update this to the correct image URL
                                  alt={'avatar-' + speaker.name}
                                />
                                <div className="text-left">
                                  <div className="font-bold text-xl mb-1 text-purple-800">{speaker.name}</div>
                                  <p className="text-gray-600 text-sm text-purple-800">{speaker.profession}</p>
                                </div>
                              </div>
                              <div className="flex items-center mt-4">
                                <div className="flex-1 text-left border-r border-purple-800 pr-4">
                                  <p className="text-gray-600 fs-6 text-purple-800 text-start mt-2">{speaker.work_position}</p>
                                </div>
                                <div className="flex flex-col items-center pl-4">
                                  <img
                                    className="w-6 h-6 mb-2"
                                    src={speaker.country_id.flag}
                                    alt={'flag-' + speaker.country_id.country_name}
                                  />
                                  <p className="text-sm text-purple-800">{speaker.country_id.country_name}</p>
                                </div>
                              </div>
                            </React.Fragment>
                          ))}
                        </Carousel>
                      </div>
                      {/* chat */}
                      <iframe
                        className="bg-gray-100 w-full h-[400px] p-3 rounded-xl flex flex-col" // Cambia h-96 por la altura deseada
                        title="chatMoc"
                        src={event.url_chat + encodeURIComponent(name + ' ' + lastName)}
                      ></iframe>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default EventInformationComponent;